import { ON_HOLD, REJECTED, WAITING_APPROVAL } from '@/constants/document-file-statuses';

export const APPROVAL_STATUS_FILTER_OPTIONS = [
  { statusId: WAITING_APPROVAL, status: 'Awaiting Approval' },
  { statusId: ON_HOLD, status: 'On Hold' },
  { statusId: REJECTED, status: 'Rejected' },
];
